/**
 * Page schema
 * @param {object} data
 * @param {object} data.route
 * @returns {object}
 */
export const pageSchema = ({ route }) => {
	return {
		name: route.meta.name,
		tracking: route.meta.tracking,
		number: route.meta.number,
		forms: route.meta.forms,
		isBlankPage: route.meta.isBlankPage
	};
};

